import { DateTimeTz } from "@web-app/components";
import { timeZoneMap } from "@web-app/utils/helpers";

export default function DateWindowCell({
  value,
}: {
  value: {
    end: Date;
    start: Date;
    timezone: keyof typeof timeZoneMap;
  } | null;
}) {
  if (!value) return null;

  return (
    <div>
      <DateTimeTz
        presentation="flat"
        showIcon={false}
        start={new Date(value.start)}
        end={new Date(value.end)}
        timezone={value.timezone}
      />
    </div>
  );
}
